import React from "react";
import TrainCard from "literacy/assets/cards/trainpagecard";
import { Container, Button } from "@material-ui/core";

class PhonemeTutorMain extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <div>
        <div className="jumbotron">
          <h2>Welcome to Sound Training Tutor main page</h2>
          <br />
          <Button
            variant="contained"
            style={{ color: "white", backgroundColor: "#107896" }}
            href="/literacy"
          >
            Go back
          </Button>
        </div>
        <Container>
          <h3>Review Students' Assignments and Performance</h3>
          <div className="row">
            <TrainCard
              title="Students' Assignment"
              page="/literacy/tutor/phoneme/assign"
              description="In this part, you can check students' assignments"
            />
            <TrainCard
              title="Students' Performance"
              page="/literacy/tutor/phoneme/performance"
              description="In this part, you can check students' performance"
            />
          </div>
          <h3>Modify Phoneme Database</h3>
          <div className="row">
            <TrainCard
              title="Modify Learning Materials"
              page="/literacy/tutor/phoneme/materials"
              description="In this part, you can modify phoneme learning materilas"
            />
            {/* <TrainCard
              title="Modify Phoneme Data"
              page="/literacy/tutor/phoneme/phonemedata"
              description="In this part, you can modify phoneme data"
            /> */}
            {/* <TrainCard
              title="Modify Audio data"
              page="/literacy/tutor/phoneme/audiodata"
              description="In this part, you can modify audio data"
            /> */}
            <TrainCard
              title="Modify Multiple Choices data"
              page="/literacy/tutor/phoneme/multiple"
              description="In this part, you can modify mutiple-choice question data"
            />
            <TrainCard
              title="Modify Blank data"
              page="/literacy/tutor/phoneme/blank"
              description="In this part, you can modify blank question data"
            />
            <TrainCard
              title="Modify True False data"
              page="/literacy/tutor/phoneme/truefalse"
              description="In this part, you can modify true false question data"
            />
          </div>
        </Container>
      </div>
    );
  }
}

export default PhonemeTutorMain;
